<template>
<div>
    <!-- Universal Disclosure -->

    <div v-for="category in report_universal_categories" :key="category.category_id">
        <h3 :id="'rp'+category.category_id" class="py-4 fw-600">GRI {{ category.category_id }}. {{ lang!='ENG'? category.category_name: category.category_name_e}}</h3>
        <b-table-simple responsive class="disclosure-table lg border-bottom mb-5">
            <b-thead><b-tr>
                <b-td style="min-width:22%; width:32%;">{{ lang!='ENG'? '보고 지표' :'Disclosures' }}
                    <header-anchor :active_code="category.category_id" :print_mode="print_mode"></header-anchor>
                </b-td>
                <b-td class="d-lg-flex justify-content-between">{{ lang!='ENG'? '보고 내용' :'Disclosure Contents' }}
                    <div class="f-90"> <fa icon="table" class="mr-1"/> {{ lang!='ENG'?'데이터 테이블': 'Data Tables' }} <fa icon="file-alt" class="ml-3 mr-1"/>{{ lang!='ENG'?'문서': 'Files' }} <fa icon="external-link-square-alt" class="ml-3 mr-1"/> {{ lang!='ENG'?'외부 링크': 'URLs' }} <fa icon="quote-left" class="ml-3 mr-1"/> {{ lang!='ENG'?'비즈니스 사례': 'Business Cases' }} </div>
                </b-td>
            </b-tr></b-thead>
            <b-tbody v-for="subtopic, index in getUniqueSubtopicsByCategoryIds(category.category_id)" :id="'rp'+subtopic.subtopic_code"  :key="subtopic.subtopic_code" class="mb-2 border-0">
                <b-tr><b-td colspan="2" class="py-1 pl-1 f-120 fw-600" :style="main_color_sub"> {{ index+1 }}. {{ lang!='ENG'? subtopic.subtopic_name : subtopic.subtopic_name_e }} </b-td></b-tr>             
                <b-tr v-for="disclosure in getGRIContentsBySubtopicCodes(subtopic.subtopic_code)" :key="disclosure.disclosure_id" >
                    <b-td :id="'crp'+subtopic.subtopic_code" class="pr-4 d-flex flex-column">
                        <div class="fw-500">{{ disclosure.gri_code }}</div>
                        <p class=""> {{ lang!='ENG'? disclosure.indicator_name : disclosure.indicator_name_e }}</p>
                    </b-td>
                    <b-td class="">

                        <md :contents="lang!='ENG'? disclosure.direct_report: disclosure.direct_report != null ? disclosure.direct_report_e : '' " :class="disclosure.direct_report? 'mb-3':''" ></md> 
                        
                        <!-- data_tables 넣을자리 -->
                        <div v-for="data_table_id in disclosure.data_tables" :key="'data_table_' + data_table_id">
                            <data-table :data_table_id="data_table_id" :modal_table="modal_table" :lazy_load="false"></data-table>
                        </div>
                        
                        <!-- documents 넣을자리 -->
                        <div>
                            <span v-for="document_id in disclosure.documents" :key="'document_' + document_id">
                                <document :document_id="document_id" :lazy_load="false"></document>
                            </span>
                        </div>

                        <!-- business_cases 넣을자리 -->
                        <span v-for="business_case_id in disclosure.business_cases" :key="'business_case_' + business_case_id">
                            <business-case :business_case_id="business_case_id" :lazy_load="false"></business-case>
                        </span>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
    <hr class="border-0 py-5">
    <!-- GRI 200 ~ 400 -->

    <div v-for="category in report_topic_specific_categories" :key="category.category_id">
        <template v-if="getGRIContentsByCategoryIds(category.category_id).length>0">
            <h3 :id="'rp'+category.category_id" class="py-4 fw-600"> GRI {{category.category_id}}. {{ lang!='ENG'? category.category_name: category.category_name_e}}</h3>

            <b-table-simple responsive class="disclosure-table lg border-bottom mb-5">
                <b-thead><b-tr>
                    <b-td style="min-width:22%; width:32%;">{{ lang!='ENG'? '보고 지표' :'Disclosures' }}
                        <header-anchor :active_code="category.category_id" :print_mode="print_mode"></header-anchor>
                    </b-td>
                    <b-td class="d-lg-flex justify-content-between">{{ lang!='ENG'? '보고 내용' :'Disclosure Contents' }}
                    <div class="f-90"> <fa icon="table" class="mr-1"/> {{ lang!='ENG'?'데이터 테이블': 'Data Tables' }} <fa icon="file-alt" class="ml-3 mr-1"/>{{ lang!='ENG'?'문서': 'Files' }} <fa icon="external-link-square-alt" class="ml-3 mr-1"/> {{ lang!='ENG'?'외부 링크': 'URLs' }} <fa icon="quote-left" class="ml-3 mr-1"/> {{ lang!='ENG'?'비즈니스 사례': 'Business Cases' }} </div>
                    </b-td>
                </b-tr></b-thead>
                <b-tbody v-for="topic in getUniqueTopicsByCategoryIds(category.category_id)" :id="'rp'+topic.topic_id"  :key="topic.topic_id" class="mb-2 border-0">
                    <b-tr><b-td colspan="2" class="py-1 pl-1 fw-500 f-120 " :style="main_color_sub"> GRI {{ topic.topic_id }} : {{ lang!='ENG'? topic.topic_name : topic.topic_name_e }}</b-td></b-tr>                
                    <b-tr v-for="disclosure in getGRIContentsByTopicIds(topic.topic_id) " :key="disclosure.disclosure_id">
                        <b-td :id="'crp'+topic.topic_id" class="pr-4 d-flex flex-column">
                            <div class="fw-500">{{ disclosure.gri_code }}</div>
                            <p class=""> {{ lang!='ENG'? disclosure.indicator_name : disclosure.indicator_name_e }}</p>
                        </b-td>
                        <b-td class="">
                            <md :contents="lang!='ENG'? disclosure.direct_report: disclosure.direct_report_e" :class="disclosure.direct_report? 'mb-3':''"></md>
                            <!-- data_tables 넣을자리 -->
                            <div v-for="data_table_id in disclosure.data_tables" :key="'data_table_' + data_table_id">
                                <data-table :data_table_id="data_table_id" :modal_table="modal_table" :lazy_load="false"></data-table>
                            </div>
                            
                            <!-- documents 넣을자리 -->
                            <div>
                                <span v-for="document_id in disclosure.documents" :key="'document_' + document_id">
                                    <document :document_id="document_id" :lazy_load="false"></document>
                                </span>
                            </div>

                            <!-- business_cases 넣을자리 -->
                            <span v-for="business_case_id in disclosure.business_cases" :key="'business_case_' + business_case_id">
                                <business-case :business_case_id="business_case_id" :lazy_load="false"></business-case>
                            </span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </template>
    </div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import * as ih from '@/components/util'
import DataTable from './DataTable.vue'
import Document from './Document.vue'
import BusinessCase from './BusinessCase.vue'
import HeaderAnchor from './HeaderAnchor'

export default {
    components:{
        DataTable,
        Document,
        BusinessCase,
        HeaderAnchor
    },
    data() {
        return {
            show_data_table: {},
            show_business_case: {},
            low_height: false,
        }
    },    
    props:{
        modal_table: { type: Boolean, default: false},
        reload: { type: Boolean, default: false },
        print_mode: {type: Boolean, default: false}
    },
    computed:{
        ...mapState('report_list', ['report_code', 'lang', 'view_mode']),
        ...mapState('gri2021_report_view', ['report_structure', 'report_contents_loaded']),
        ...mapGetters('gri2021_report_view', ['report_topics', 'report_categories', 'report_universal_categories', 'report_topic_specific_categories']),
        ...mapGetters('report_list', ['selected_report']),
        main_color(){
            return `color:`+this.selected_report.main_color
        },
        main_color_sub(){
            return `color:`+this.selected_report.main_color+`; border-top: 1px solid `+this.selected_report.main_color+`!important`+`; border-bottom: 1px solid `+this.selected_report.main_color
        },
        main_bg_color(){
            if(this.selected_report){
                return `background-color:`+this.selected_report.main_color
            }
            else return `background-color: #494949`
        }           
    },
    methods: {
        ...mapMutations('gri2021_report_view', ['update_report_contents_loaded']),
        ...mapActions('gri2021_report_view', ['readReportContents']),
        ...mapActions('data_tables', ['readDataTableList']),
        ...mapActions('business_cases', ['readBusinessCaseList']),
        ...mapActions('documents', ['readDocumentList']),
        getUniqueTopicsByCategoryIds(category_id){
        //[{ category_id, category_name, category_name_e, topic_id, topic_name, topic_name_e }]
            let filtered_structure = this.report_structure.filter(item => item.category_id == category_id )       
            let unique_topics = []
            filtered_structure.forEach( item => {
                if ( unique_topics.findIndex( x=> { return x.topic_id == item.topic_id }) < 0) {
                    unique_topics.push({ category_id: item.category_id, category_name: item.category_name, category_name_e: item.category_name_e, 
                        topic_id: item.topic_id, topic_name: item.topic_name, topic_name_e: item.topic_name_e })
                }
            })
            return unique_topics
        },
        getUniqueSubtopicsByCategoryIds(category_id){
        //[{ category_id, category_name, category_name_e, topic_id, topic_name, topic_name_e }]
            let filtered_structure = this.report_structure.filter(item => item.category_id == category_id )       
            let unique_subtopics = []
            filtered_structure.forEach( item => {
                if ( unique_subtopics.findIndex( x=> { return x.subtopic_code == item.subtopic_code }) < 0) {
                    unique_subtopics.push({ category_id: item.category_id, category_name: item.category_name, category_name_e: item.category_name_e, 
                        subtopic_code: item.subtopic_code, subtopic_name: item.subtopic_name, subtopic_name_e: item.subtopic_name_e })
                }
            })
            return unique_subtopics            
        },
        getGRIContentsByCategoryIds(category_id){
        //[{ category_id, category_name, category_name_e, topic_id, topic_name, topic_name_e, inidcator_id }]
            let filtered_structure = this.report_structure.filter(item => item.category_id == category_id )
            return filtered_structure
        },
        getGRIContentsByTopicIds(topic_id){
        // [{ category_id, category_name, category_name_e, topic_id, topic_name, topic_name_e, gri_code, indicator_id, disclosure_id }]
            let filtered_structure = this.report_structure.filter(item => item.topic_id == topic_id)
            return filtered_structure
        },
        getGRIContentsBySubtopicCodes(subtopic_code){
        // [{ category_id, category_name, category_name_e, topic_id, topic_name, topic_name_e, gri_code, indicator_id, disclosure_id }]
            let filtered_structure = this.report_structure.filter(item => item.subtopic_code == subtopic_code)
            return filtered_structure
        },
    },
    created(){
        if(this.reload==true){
            this.update_report_contents_loaded(false)
        }

        if(this.report_contents_loaded == false){
            // console.log('GRI_TABLE_LOAD')
            this.readReportContents({report_code : this.report_code})
            this.readDataTableList({report_code: this.report_code})
            this.readBusinessCaseList({report_code: this.report_code})
            this.readDocumentList({report_code:this.report_code})
        }
    }
}
</script>